export const en = {
  'segments.title': 'Tags and segments',
  'segments.description': 'Tag members by hand, and save groups of members by rules to filter the members list and text a campaign.',
  'segments.tab.segments': 'Segments',
  'segments.tab.tags': 'Tags',
  'segments.new': 'New segment',
  'segments.empty': 'No segments yet',
  'segments.emptyHint': 'A segment is a saved group of members, such as “membership active, no visit in 30 days”. It updates itself as members come and go.',
  'segments.members.one': '{count} member',
  'segments.members.other': '{count} members',
  'segments.countUnavailable': 'Not available',
  'segments.invalid': 'These rules no longer work. Open the segment and save it again.',
  'segments.showMembers': 'Show members',
  'segments.editName': 'Edit {name}',
  'segments.deleteName': 'Delete {name}',
  'segments.deleteTitle': 'Delete this segment?',
  'segments.deleteDescription': '“{name}” will be deleted. Campaign texts already sent to it keep their record.',
  'segments.deleted': 'Segment deleted',
  'segments.saved': 'Segment saved',
  'segments.createdBy': 'by {name}',
  'segments.field.name': 'Name',
  'segments.field.description': 'Description',
  'segments.rules': 'Rules',
  'segments.rulesHint': 'A member is in the segment when every rule holds.',
  'segments.noRules': 'No rules yet: the segment holds every member.',
  'segments.addRule': 'Add a rule',
  'segments.removeRule': 'Remove the rule “{rule}”',
  'segments.liveCount.one': '{count} member right now',
  'segments.liveCount.other': '{count} members right now',
  'segments.finishRules': 'Finish the rules to see how many members they hold.',
  'segments.counting': 'Counting…',
  'segments.save': 'Save segment',
  'segments.rule.hasTag': 'Has a tag',
  'segments.rule.lacksTag': 'Does not have a tag',
  'segments.rule.membershipStatus': 'Membership now',
  'segments.rule.plan': 'Plan',
  'segments.rule.visitedBranch': 'Visited a branch',
  'segments.rule.joined': 'Joined between',
  'segments.rule.lastVisit': 'Last visit',
  'segments.rule.noVisitWithin': 'No visit lately',
  'segments.rule.membershipEndsWithin': 'Membership ends soon',
  'segments.rule.membershipEndedWithin': 'Membership ended lately',
  'segments.rule.birthdayThisMonth': 'Birthday this month',
  'segments.rule.gender': 'Gender',
  'segments.rule.age': 'Age',
  'segments.rule.smsOffers': 'Offers by SMS',
  'segments.rule.balanceBelow': 'Balance below',
  'segments.ruleHint.hasTag': 'Any of the tags chosen.',
  'segments.ruleHint.lacksTag': 'None of the tags chosen.',
  'segments.ruleHint.membershipStatus': 'The membership the member stands on now: active first, then frozen, suspended, waiting for payment, expired.',
  'segments.ruleHint.plan': 'The plan of the membership the member stands on now.',
  'segments.ruleHint.visitedBranch': 'Came in at one of these branches.',
  'segments.ruleHint.noVisitWithin': 'Members who never came in count too.',
  'segments.ruleHint.membershipEndsWithin': 'An active membership whose last day is that close; a membership already bought to follow it counts.',
  'segments.ruleHint.membershipEndedWithin': 'Expired or cancelled that recently, and holding no membership now.',
  'segments.ruleHint.age': 'Members without a date of birth are left out.',
  'segments.ruleHint.balanceBelow': 'A member without a balance has 0.',
  'segments.field.tags': 'Tags',
  'segments.field.states': 'States',
  'segments.field.plans': 'Plans',
  'segments.field.branches': 'Branches',
  'segments.field.withinDays': 'In the last (days)',
  'segments.field.withinDaysHint': 'Leave empty for any visit.',
  'segments.field.from': 'From',
  'segments.field.to': 'To',
  'segments.field.after': 'On or after',
  'segments.field.before': 'Before',
  'segments.field.days': 'Days',
  'segments.field.minAge': 'From age',
  'segments.field.maxAge': 'To age',
  'segments.field.genders': 'Genders',
  'segments.field.answer': 'Answer',
  'segments.field.amount': 'Amount ({currency})',
  'segments.smsOffers.yes': 'Agreed to offers by SMS',
  'segments.smsOffers.no': 'Has not agreed',
  'segments.noTagsYet': 'The gym has no tags yet.',
  'segments.state.ACTIVE': 'Active',
  'segments.state.PAUSED': 'Frozen',
  'segments.state.SUSPENDED': 'Suspended',
  'segments.state.PENDING': 'Waiting for payment',
  'segments.state.EXPIRED': 'Expired',
  'segments.state.NONE': 'No membership',
  'segments.summary.everyone': 'Every member',
  'segments.summary.hasTag': 'Tagged {tags}',
  'segments.summary.lacksTag': 'Not tagged {tags}',
  'segments.summary.membershipStatus': 'Membership: {states}',
  'segments.summary.plan': 'On {plans}',
  'segments.summary.visitedBranch': 'Visited {branches}',
  'segments.summary.visitedBranchWithin.one': 'Visited {branches} in the last day',
  'segments.summary.visitedBranchWithin.other': 'Visited {branches} in the last {count} days',
  'segments.summary.joined': 'Joined {from} – {to}',
  'segments.summary.joinedFrom': 'Joined on or after {from}',
  'segments.summary.joinedTo': 'Joined on or before {to}',
  'segments.summary.lastVisit': 'Last visit on or after {after} and before {before}',
  'segments.summary.lastVisitAfter': 'Last visit on or after {after}',
  'segments.summary.lastVisitBefore': 'Last visit before {before}',
  'segments.summary.noVisitWithin.one': 'No visit in the last day',
  'segments.summary.noVisitWithin.other': 'No visit in the last {count} days',
  'segments.summary.membershipEndsWithin.one': 'Membership ends within a day',
  'segments.summary.membershipEndsWithin.other': 'Membership ends within {count} days',
  'segments.summary.membershipEndedWithin.one': 'Membership ended in the last day',
  'segments.summary.membershipEndedWithin.other': 'Membership ended in the last {count} days',
  'segments.summary.birthdayThisMonth': 'Birthday this month',
  'segments.summary.gender': 'Gender: {genders}',
  'segments.summary.age': 'Aged {min} to {max}',
  'segments.summary.ageFrom': 'Aged {min} or older',
  'segments.summary.ageTo': 'Aged {max} or younger',
  'segments.summary.balanceBelow': 'Balance under {amount}',
  'tags.new': 'New tag',
  'tags.empty': 'No tags yet',
  'tags.emptyHint': 'Tags are labels staff give members by hand, such as “student”, “VIP” or “injury”. They show on the member page and at the desk.',
  'tags.members.one': '{count} member',
  'tags.members.other': '{count} members',
  'tags.field.name': 'Name',
  'tags.field.color': 'Colour',
  'tags.field.description': 'Description',
  'tags.field.descriptionHint': 'What the tag means, for whoever gives it.',
  'tags.color.gray': 'Grey',
  'tags.color.blue': 'Blue',
  'tags.color.orange': 'Orange',
  'tags.color.teal': 'Teal',
  'tags.color.amber': 'Amber',
  'tags.color.pink': 'Pink',
  'tags.color.green': 'Green',
  'tags.color.purple': 'Purple',
  'tags.color.red': 'Red',
  'tags.added': 'Tag added',
  'tags.updated': 'Tag saved',
  'tags.deleted': 'Tag deleted',
  'tags.editName': 'Edit {name}',
  'tags.deleteName': 'Delete {name}',
  'tags.deleteTitle': 'Delete this tag?',
  'tags.deleteDescription.one': '“{name}” will be taken off {count} member.',
  'tags.deleteDescription.other': '“{name}” will be taken off {count} members.',
  'tags.inSegments': 'Segments use this tag: {segments}. Take it out of them first.',
  'memberTags.title': 'Tags',
  'memberTags.edit': 'Edit tags',
  'memberTags.editFor': 'Edit the tags of {name}',
  'memberTags.none': 'No tags',
  'memberTags.manage': 'Manage tags',
};

export const ka: Record<keyof typeof en, string> = {
  'segments.title': 'ტეგები და სეგმენტები',
  'segments.description': 'მონიშნეთ წევრები ტეგებით და შეინახეთ წევრთა ჯგუფები წესებით, წევრების სიის გასაფილტრად და აქციის SMS-ით გასაგზავნად.',
  'segments.tab.segments': 'სეგმენტები',
  'segments.tab.tags': 'ტეგები',
  'segments.new': 'ახალი სეგმენტი',
  'segments.empty': 'სეგმენტები ჯერ არ არის',
  'segments.emptyHint': 'სეგმენტი არის წევრთა შენახული ჯგუფი, მაგალითად „აქტიური აბონემენტი, 30 დღეა არ მოსულა“. ის თავისით ახლდება, როცა წევრები მოდიან და მიდიან.',
  'segments.members.one': '{count} წევრი',
  'segments.members.other': '{count} წევრი',
  'segments.countUnavailable': 'მიუწვდომელია',
  'segments.invalid': 'ეს წესები აღარ მუშაობს. გახსენით სეგმენტი და ხელახლა შეინახეთ.',
  'segments.showMembers': 'წევრების ნახვა',
  'segments.editName': '{name} — რედაქტირება',
  'segments.deleteName': '{name} — წაშლა',
  'segments.deleteTitle': 'წაიშალოს ეს სეგმენტი?',
  'segments.deleteDescription': '„{name}“ წაიშლება. მასზე უკვე გაგზავნილი აქციების SMS-ების ჩანაწერი დარჩება.',
  'segments.deleted': 'სეგმენტი წაიშალა',
  'segments.saved': 'სეგმენტი შენახულია',
  'segments.createdBy': 'შექმნა: {name}',
  'segments.field.name': 'სახელწოდება',
  'segments.field.description': 'აღწერა',
  'segments.rules': 'წესები',
  'segments.rulesHint': 'წევრი სეგმენტშია, როცა ყველა წესი სრულდება.',
  'segments.noRules': 'წესები ჯერ არ არის: სეგმენტში ყველა წევრია.',
  'segments.addRule': 'წესის დამატება',
  'segments.removeRule': 'წესის „{rule}“ წაშლა',
  'segments.liveCount.one': 'ახლა {count} წევრი',
  'segments.liveCount.other': 'ახლა {count} წევრი',
  'segments.finishRules': 'დაასრულეთ წესები, რომ ნახოთ, რამდენი წევრია მათში.',
  'segments.counting': 'ითვლება…',
  'segments.save': 'სეგმენტის შენახვა',
  'segments.rule.hasTag': 'აქვს ტეგი',
  'segments.rule.lacksTag': 'არ აქვს ტეგი',
  'segments.rule.membershipStatus': 'აბონემენტი ახლა',
  'segments.rule.plan': 'პაკეტი',
  'segments.rule.visitedBranch': 'ეწვია ფილიალს',
  'segments.rule.joined': 'გაწევრიანდა პერიოდში',
  'segments.rule.lastVisit': 'ბოლო ვიზიტი',
  'segments.rule.noVisitWithin': 'დიდი ხანია არ მოსულა',
  'segments.rule.membershipEndsWithin': 'აბონემენტი მალე სრულდება',
  'segments.rule.membershipEndedWithin': 'აბონემენტი ახლახან დასრულდა',
  'segments.rule.birthdayThisMonth': 'დაბადების დღე ამ თვეში',
  'segments.rule.gender': 'სქესი',
  'segments.rule.age': 'ასაკი',
  'segments.rule.smsOffers': 'შეთავაზებები SMS-ით',
  'segments.rule.balanceBelow': 'ბალანსი ნაკლებია',
  'segments.ruleHint.hasTag': 'არჩეული ტეგებიდან ნებისმიერი.',
  'segments.ruleHint.lacksTag': 'არჩეული ტეგებიდან არც ერთი.',
  'segments.ruleHint.membershipStatus': 'აბონემენტი, რომელზეც წევრი ახლა დგას: ჯერ აქტიური, შემდეგ გაყინული, შეჩერებული, გადახდის მოლოდინში, ვადაგასული.',
  'segments.ruleHint.plan': 'აბონემენტის პაკეტი, რომელზეც წევრი ახლა დგას.',
  'segments.ruleHint.visitedBranch': 'შემოვიდა ამ ფილიალებიდან ერთ-ერთში.',
  'segments.ruleHint.noVisitWithin': 'ითვლებიან ისინიც, ვინც საერთოდ არ მოსულა.',
  'segments.ruleHint.membershipEndsWithin': 'აქტიური აბონემენტი, რომლის ბოლო დღე ამდენად ახლოსაა; ითვლება მის შემდეგ უკვე ნაყიდი აბონემენტიც.',
  'segments.ruleHint.membershipEndedWithin': 'ვადა გაუვიდა ან გაუქმდა ამ პერიოდში და ახლა აბონემენტი არ აქვს.',
  'segments.ruleHint.age': 'წევრები დაბადების თარიღის გარეშე არ ითვლება.',
  'segments.ruleHint.balanceBelow': 'წევრს ბალანსის გარეშე 0 აქვს.',
  'segments.field.tags': 'ტეგები',
  'segments.field.states': 'მდგომარეობები',
  'segments.field.plans': 'პაკეტები',
  'segments.field.branches': 'ფილიალები',
  'segments.field.withinDays': 'ბოლო (დღე)',
  'segments.field.withinDaysHint': 'დატოვეთ ცარიელი ნებისმიერი ვიზიტისთვის.',
  'segments.field.from': 'დან',
  'segments.field.to': 'მდე',
  'segments.field.after': 'ამ დღიდან',
  'segments.field.before': 'ამ დღემდე',
  'segments.field.days': 'დღე',
  'segments.field.minAge': 'ასაკი დან',
  'segments.field.maxAge': 'ასაკი მდე',
  'segments.field.genders': 'სქესი',
  'segments.field.answer': 'პასუხი',
  'segments.field.amount': 'თანხა ({currency})',
  'segments.smsOffers.yes': 'დათანხმდა შეთავაზებებს SMS-ით',
  'segments.smsOffers.no': 'არ დათანხმებულა',
  'segments.noTagsYet': 'დარბაზს ტეგები ჯერ არ აქვს.',
  'segments.state.ACTIVE': 'აქტიური',
  'segments.state.PAUSED': 'გაყინული',
  'segments.state.SUSPENDED': 'შეჩერებული',
  'segments.state.PENDING': 'გადახდის მოლოდინში',
  'segments.state.EXPIRED': 'ვადაგასული',
  'segments.state.NONE': 'აბონემენტის გარეშე',
  'segments.summary.everyone': 'ყველა წევრი',
  'segments.summary.hasTag': 'ტეგით: {tags}',
  'segments.summary.lacksTag': 'ტეგის გარეშე: {tags}',
  'segments.summary.membershipStatus': 'აბონემენტი: {states}',
  'segments.summary.plan': 'პაკეტი: {plans}',
  'segments.summary.visitedBranch': 'ეწვია: {branches}',
  'segments.summary.visitedBranchWithin.one': 'ეწვია: {branches}, ბოლო დღეს',
  'segments.summary.visitedBranchWithin.other': 'ეწვია: {branches}, ბოლო {count} დღეში',
  'segments.summary.joined': 'გაწევრიანდა {from} – {to}',
  'segments.summary.joinedFrom': 'გაწევრიანდა {from}-დან',
  'segments.summary.joinedTo': 'გაწევრიანდა {to}-მდე ჩათვლით',
  'segments.summary.lastVisit': 'ბოლო ვიზიტი {after}-დან {before}-მდე',
  'segments.summary.lastVisitAfter': 'ბოლო ვიზიტი {after}-დან',
  'segments.summary.lastVisitBefore': 'ბოლო ვიზიტი {before}-მდე',
  'segments.summary.noVisitWithin.one': 'ბოლო დღეს არ მოსულა',
  'segments.summary.noVisitWithin.other': 'ბოლო {count} დღეში არ მოსულა',
  'segments.summary.membershipEndsWithin.one': 'აბონემენტი სრულდება ერთ დღეში',
  'segments.summary.membershipEndsWithin.other': 'აბონემენტი სრულდება {count} დღეში',
  'segments.summary.membershipEndedWithin.one': 'აბონემენტი დასრულდა ბოლო დღეს',
  'segments.summary.membershipEndedWithin.other': 'აბონემენტი დასრულდა ბოლო {count} დღეში',
  'segments.summary.birthdayThisMonth': 'დაბადების დღე ამ თვეში',
  'segments.summary.gender': 'სქესი: {genders}',
  'segments.summary.age': 'ასაკი {min}-დან {max}-მდე',
  'segments.summary.ageFrom': 'ასაკი {min} და მეტი',
  'segments.summary.ageTo': 'ასაკი {max} და ნაკლები',
  'segments.summary.balanceBelow': 'ბალანსი {amount}-ზე ნაკლები',
  'tags.new': 'ახალი ტეგი',
  'tags.empty': 'ტეგები ჯერ არ არის',
  'tags.emptyHint': 'ტეგები არის ნიშნები, რომლებსაც პერსონალი ხელით ანიჭებს წევრებს, მაგალითად „სტუდენტი“, „VIP“ ან „ტრავმა“. ისინი ჩანს წევრის გვერდზე და მიმღებში.',
  'tags.members.one': '{count} წევრი',
  'tags.members.other': '{count} წევრი',
  'tags.field.name': 'სახელწოდება',
  'tags.field.color': 'ფერი',
  'tags.field.description': 'აღწერა',
  'tags.field.descriptionHint': 'რას ნიშნავს ტეგი, მისთვის, ვინც მას მიანიჭებს.',
  'tags.color.gray': 'ნაცრისფერი',
  'tags.color.blue': 'ლურჯი',
  'tags.color.orange': 'ნარინჯისფერი',
  'tags.color.teal': 'ზურმუხტისფერი',
  'tags.color.amber': 'ქარვისფერი',
  'tags.color.pink': 'ვარდისფერი',
  'tags.color.green': 'მწვანე',
  'tags.color.purple': 'იისფერი',
  'tags.color.red': 'წითელი',
  'tags.added': 'ტეგი დაემატა',
  'tags.updated': 'ტეგი შენახულია',
  'tags.deleted': 'ტეგი წაიშალა',
  'tags.editName': '{name} — რედაქტირება',
  'tags.deleteName': '{name} — წაშლა',
  'tags.deleteTitle': 'წაიშალოს ეს ტეგი?',
  'tags.deleteDescription.one': '„{name}“ მოეხსნება {count} წევრს.',
  'tags.deleteDescription.other': '„{name}“ მოეხსნება {count} წევრს.',
  'tags.inSegments': 'ამ ტეგს იყენებს სეგმენტები: {segments}. ჯერ ამოიღეთ იქიდან.',
  'memberTags.title': 'ტეგები',
  'memberTags.edit': 'ტეგების შეცვლა',
  'memberTags.editFor': '{name} — ტეგების შეცვლა',
  'memberTags.none': 'ტეგები არ არის',
  'memberTags.manage': 'ტეგების მართვა',
};
